export default {
  path: '/wecode/form-resources/:formId/:uuid/:fileName',
  auth: false,
  preload: false,
  key: 'formResources',
  component: () => import('./index')
};
